export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14621.66fd32df.jpg";